import type { ComponentType, SVGProps } from 'react';

import { ReactComponent as BinTableIcon } from '../../react-icons/quadrant-modes/bin-table.svg';
import { ReactComponent as CorrelationIcon } from '../../react-icons/quadrant-modes/correlation.svg';
import { ReactComponent as HiddenIcon } from '../../react-icons/quadrant-modes/hidden.svg';
import { ReactComponent as LineIcon } from '../../react-icons/quadrant-modes/line.svg';
import { ReactComponent as ManeuversIcon } from '../../react-icons/quadrant-modes/maneuvers.svg';
import { ReactComponent as MapIcon } from '../../react-icons/quadrant-modes/map.svg';
import { ReactComponent as PerformanceIcon } from '../../react-icons/quadrant-modes/performance.svg';
import { ReactComponent as PolarIcon } from '../../react-icons/quadrant-modes/polar.svg';
import { ReactComponent as ScatterIcon } from '../../react-icons/quadrant-modes/scatter.svg';
import { ReactComponent as StatisticsIcon } from '../../react-icons/quadrant-modes/statistics.svg';

import type { PanelMode } from '../../types';

type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const QUADRANT_MODE_ICONS: Record<PanelMode, SvgIconComponent> = {
  binTable: BinTableIcon,
  correlation: CorrelationIcon,
  line: LineIcon,
  lineup: StatisticsIcon,
  maneuvers: ManeuversIcon,
  map: MapIcon,
  none: HiddenIcon,
  performanceBuckets: PerformanceIcon,
  polar: PolarIcon,
  scatter: ScatterIcon,
};

type QuadrantModeIconProperties = Omit<SVGProps<SVGSVGElement>, 'mode'> & {
  mode: PanelMode;
};

export function QuadrantModeIcon({ mode, className, ...properties }: QuadrantModeIconProperties) {
  const Icon = QUADRANT_MODE_ICONS[mode];
  const classes = ['quadrant-mode-icon', className].filter(Boolean).join(' ');

  return <Icon aria-hidden="true" focusable="false" className={classes} {...properties} />;
}
